import { isFunction } from 'lodash-es';
import { onBeforeUnmount } from 'vue';
import { RouteLocationNormalizedLoaded, useRouter } from 'vue-router';

export function useRouterHelpers() {
    const { currentRoute } = useRouter();

    /**
     * Event handler that gets fired when the route is updated due to browser navigation i.e. via back/forward button
     * @param callback Callback to execute
     */
    const onHistoryPopState = (callback: (params: RouteLocationNormalizedLoaded) => void) => {
        if (!isFunction(callback)) return;

        function _callback() {
            callback({ ...currentRoute.value, query: Object.fromEntries(new URLSearchParams(window.location.search)) });
        }

        window.addEventListener('popstate', _callback);

        onBeforeUnmount(() => window.removeEventListener('popstate', _callback));
    };

    return {
        onHistoryPopState
    };
}
